<template>
  <div>
    <!-- Add Plot Button -->
    <b-button v-b-modal.modal-2 size="sm" variant="success">Add Plot</b-button>

    <!-- Modal for Creating New Plot -->
    <b-modal id="modal-2" title="Create New Plot">
      <b-alert variant="success" v-if="successMessage" show> {{ successMessage }} </b-alert>
      <b-alert variant="danger" v-if="validationErrors" show> {{ validationErrors }} </b-alert>
     
      <b-form @submit.prevent="submitPlotForm">
        <div class="row">
          <div class="col-md-12">
            <!-- Project Name -->
            <b-form-group label="Project Name :" class="font-weight-bold">
              {{ projectName }}
            </b-form-group>

            <!-- Zone Code -->
            <b-form-group label="Zone :" class="font-weight-bold">
              {{ zoneCode }} - {{ projectName }}
            </b-form-group>

            <!-- Reusable Input Fields -->
            <ReusableInput v-model="plot_form.code" label="Code" placeholder="Enter Plot Code" required />
            <ReusableInput v-model="plot_form.area" label="Total Area" type="number" placeholder="Enter Total Area (In Acres)" required />
            <ReusableInput v-model="plot_form.survey_no" label="Survey No" placeholder="Enter Survey No" required />

            <!-- Plot Type Dropdown -->
            <b-form-group label="Plot Type:">
              <b-form-select v-model="plot_form.plotType" :options="plotTypes" required>
                <b-form-select-option :value="null" disabled>Please select an option</b-form-select-option>
              </b-form-select>
            </b-form-group>

            <!-- Boundaries Section -->
            <div class="row">
              <div class="col-md-6">
                <h5>Boundaries</h5>
              </div>
              <div class="col-md-6 mb-2 text-right">
                <b-button size="sm" variant="primary" @click="addPlotBoundary">New Boundary</b-button>
              </div>

              <div class="col-md-12">
                <table class="table table-sm">
                  <thead class="small thead-light">
                    <tr>
                      <th>#</th>
                      <th>Latitude</th>
                      <th>Longitude</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(boundary, index) in plot_form.boundaries" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <ReusableInput v-model="boundary.latitude" placeholder="Enter Latitude" required />
                      </td>
                      <td>
                        <ReusableInput v-model="boundary.longitude" placeholder="Enter Longitude" required />
                      </td>
                      <td>
                        <b-button size="sm" variant="danger" @click="removePlotBoundary(index)">
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-form>

      <!-- Modal Footer -->
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="success" @click="submitPlotForm">Register</b-button>
        <b-button size="sm" variant="danger" @click="close()">Close</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ReusableInput from "@/components/ReusableInput.vue"; // Importing reusable component

export default {
  components: {
    ReusableInput,
  },
  props: ["zones"],
  data() {
    return {
      plot_form: {
        _zoneID: "",
        _projectId: "",
        code: "",
        area: "",
        survey_no: "",
        boundaries: [],
        plotType: null,
      },
      successMessage: false,
      validationErrors:false,
    };
  },
  computed: {
    projectName() {
      return this.zones?._projectId?.name || "N/A";
    },
    zoneCode() {
      return this.zones?.code || "N/A";
    },
    plotTypes() {
      return this.zones?._projectId?.plotTypes || [];
    },
  },
  methods: {
    async submitPlotForm() {
      try {
        this.plot_form._zoneID = this.zones._id;
        this.plot_form._projectId = this.zones?._projectId?._id;

        const response = await window.axios.post("plot", this.plot_form);

        if (response.data.success) {
          this.successMessage = response.data.message;
          this.$emit("plotCreateEvent", response.data);
          this.resetForm();

          setTimeout(() => (this.successMessage = false), 3000);
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          // Handle validation errors (Bad Request)
          this.validationErrors = error.response.data.errors || error.response.data.message;
        } else {
          // Handle other errors (500 Internal Server Error)
          this.validationErrors = "Something went wrong. Please try again.";
          console.error("Error submitting plot:", error);
        }
      }
    },
    addPlotBoundary() {
      this.plot_form.boundaries.push({ latitude: "", longitude: "" });
    },
    removePlotBoundary(index) {
      this.plot_form.boundaries.splice(index, 1);
    },
    resetForm() {
      this.plot_form = {
        _zoneID: "",
        code: "",
        area: "",
        survey_no: "",
        boundaries: [],
        plotType: null,
      };
    },
  },
};
</script>
